import { builder } from '@builder.io/react';
// a set of widgets you can use in the editor, optional.
// import '@builder.io/widgets';
/**
 * Import all custom components so you can use in the builder.io editor
 * https://www.builder.io/c/docs/custom-react-components
 */

import './components/Banner/Banner.builder';
import './components/Countdown/Countdown.builder';
import './components/EmailWidget/EmailWidget.builder';
import './components/FAQs/FAQs.builder';
import './components/JobBoard/JobBoard.builder';
import './components/Hero/Hero.builder';
import './components/NewsletterForm/NewsletterForm.builder';
import './components/OrangeHoverCards/OrangeHoverCards.builder';
import './components/PrimaryButton/PrimaryButton.builder';
import './components/SectionHeading/SectionHeading.builder';
import './components/Schedule/Schedule.builder';
import './components/Speakers/Speakers.builder';
import './components/Sponsors/Sponsors.builder';
import './components/SponsorsTestimonials/SponsorsTestimonials.builder';
import './components/TalksList/TalksList.builder';
import './components/TeamCards/TeamCards.builder';
import './components/Testimonials/Testimonials.builder';
import './components/TextBlock/TextBlock.builder';
import './components/TicketCards/TicketCards.builder';
import './components/VideoPlayer/VideoPlayer.builder';

builder.init(process.env.GATSBY_BUILDER_PUBLIC_API_KEY);
